import gql from "graphql-tag";

export const GET_USERS = gql`
  query users($page: Int!, $limit: Int!, $filter: String!) {
    users(page: $page, filter: $filter, limit: $limit) {
      pageInfo {
        length
      }
      edges {
        node {
          _id
          first_name
          last_name
          avatar
          email
          spam
          customize_info {
            cover
            avatar
            first_name
            last_name
            current_job_title
            current_experience_number
            phone
            birthday
            nation
            gender
            status
            specific_address
            intro
            employment_history {
              position
              company
              description
            }
            location {
              title
            }
          }
          created_at
          updated_at
        }
      }
    }
  }
`;

export const GET_USER = gql`
  query user($_id: String!) {
    user(_id: $_id) {
      _id
      first_name
      last_name
      avatar
      email
      spam
      customize_info {
        cover
        avatar
        first_name
        last_name
        current_job_title
        current_job_company
        current_experience_number
        phone
        birthday
        nation
        gender
        status
        specific_address
        intro
        specific_address
        intro
        skill {
          _id
          title
        }
        language {
          lang
          level
        }
        employment_history {
          position
          company
          from_month
          to_month
          description
        }
        education_history {
          subject
          school
          qualification
          from_month
          to_month
          achievement
        }
        work_preference {
          job_location {
            _id
            title
          }
          job_level {
            _id
            title
          }
          salary
        }
      }
      created_at
      updated_at
    }
  }
`;

export const USERS_COUNT = gql`
  query users($page: Int!, $limit: Int!, $filter: String!) {
    users(page: $page, filter: $filter, limit: $limit) {
      pageInfo {
        length
      }
    }
  }
`;
